module.exports = __webpack_public_path__ + "src/assets/img/ic10.19f87d86.svg";